export class TokenAlreadyExistsException extends Error {
  constructor(message: string) {
    if(!message) message = 'Token already exists';
    super(message);
  }
}